@if (assistant.tabs().length > 1) {
  <div
    role="tablist"
    class="border-weak bg-surface flex shrink-0 items-center gap-[3px] overflow-x-auto border-b px-2 py-1.5 [scrollbar-width:thin]"
    [attr.aria-label]="'assistant.tabs.label' | translate">
    @for (tab of assistant.tabs(); track tab.id; let i = $index) {
      @let active = tab.id === assistant.activeTabId();
      @let name = title(tab) ?? ('assistant.tabs.untitled' | translate);
      @let busy = assistant.busyTabIds().has(tab.id);
      <div
        class="flex shrink-0 items-center gap-1 rounded-xs border py-0.5 pr-1 pl-2 text-xs whitespace-nowrap transition-colors"
        [class]="
          active
            ? 'bg-elevated border-default text-accent-main font-semibold shadow-xs'
            : 'text-text-secondary hover:bg-interactive border-transparent'
        ">
        <button
          #tabButton
          type="button"
          role="tab"
          class="flex max-w-40 cursor-pointer items-center gap-1.5 py-0.5"
          [id]="'assistant-tab-' + tab.id"
          [title]="name"
          [attr.aria-selected]="active"
          [attr.tabindex]="active ? 0 : -1"
          (click)="assistant.selectTab(tab.id)"
          (keydown)="onKeydown($event, i)">
          @if ((tab.streaming && !active) || busy) {
            <i
              aria-hidden="true"
              class="text-text-tertiary shrink-0 animate-spin motion-reduce:animate-none"
              [class]="ICONS.circleNotch"></i>
            <span class="sr-only">{{ 'assistant.tabs.streaming' | translate }}</span>
          }
          <span class="truncate">{{ name }}</span>
        </button>
        <button
          type="button"
          tabindex="-1"
          data-testid="close-tab"
          class="text-text-tertiary hover:text-danger hover:bg-danger-soft disabled:hover:text-text-tertiary inline-flex cursor-pointer rounded-[3px] p-px disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:bg-transparent"
          [disabled]="busy"
          [attr.aria-label]="
            (busy ? 'assistant.busy.close' : 'assistant.tabs.close')
              | translate: { title: name }
          "
          [title]="
            (busy ? 'assistant.busy.close' : 'assistant.tabs.close')
              | translate: { title: name }
          "
          (click)="assistant.closeTab(tab.id)">
          <i aria-hidden="true" [class]="ICONS.x"></i>
        </button>
      </div>
    }
  </div>
}
